import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function FloatingActions({ dark }) {
  const [isOpen, setIsOpen] = useState(false);

  const actions = [
    {
      icon: "📧",
      label: "Email",
      action: () => window.open("mailto:info@techadr.co", "_blank"),
      color: "from-blue-500 to-cyan-500",
      delay: 0.1
    },
    {
      icon: "📱",
      label: "WhatsApp",
      action: () => window.open("https://wa.me/918408993879?text=Hi%20Tech%20ADR!%20I'm%20interested%20in%20your%20services.", "_blank"),
      color: "from-green-500 to-emerald-500",
      delay: 0.2
    },
    {
      icon: "💬",
      label: "Chat",
      action: () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }),
      color: "from-purple-500 to-pink-500",
      delay: 0.3
    },
    {
      icon: "📋",
      label: "Quote",
      action: () => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" }),
      color: "from-orange-500 to-red-500",
      delay: 0.4
    }
  ];

  return (
    <div className="fixed bottom-8 left-8 z-50">
      {/* Action buttons */}
      <AnimatePresence>
        {isOpen && (
          <div className="space-y-4 mb-4">
            {actions.map((action, index) => (
              <motion.button
                key={action.label}
                initial={{ opacity: 0, scale: 0, x: -20 }}
                animate={{ opacity: 1, scale: 1, x: 0 }}
                exit={{ opacity: 0, scale: 0, x: -20 }}
                transition={{ delay: action.delay, duration: 0.3 }}
                onClick={action.action}
                className={`group relative w-14 h-14 rounded-full shadow-lg backdrop-blur-md border-2 transition-all duration-300 ${
                  dark
                    ? 'bg-[#23244d]/80 border-indigo-400/50 hover:bg-[#23244d] hover:border-indigo-400'
                    : 'bg-white/80 border-indigo-500/50 hover:bg-white hover:border-indigo-500'
                }`}
                whileHover={{ scale: 1.1, x: 5 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  background: `linear-gradient(135deg, var(--tw-gradient-stops))`,
                  '--tw-gradient-from': action.color.split('-')[1] === '500' ? '#3b82f6' : '#60a5fa',
                  '--tw-gradient-to': action.color.split('-')[3] === '500' ? '#06b6d4' : '#22d3ee'
                }}
              >
                <span className="text-xl">{action.icon}</span>
                
                {/* Tooltip */}
                <motion.div
                  initial={{ opacity: 0, x: 10 }}
                  whileHover={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.2 }}
                  className={`absolute left-full ml-3 px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap ${
                    dark
                      ? 'bg-[#23244d] text-white border border-indigo-400/50'
                      : 'bg-white text-[#1b1c4e] border border-indigo-500/50 shadow-lg'
                  }`}
                >
                  {action.label}
                  <div
                    className={`absolute top-1/2 -translate-y-1/2 left-full w-0 h-0 border-l-4 border-l-transparent ${
                      dark
                        ? 'border-l-[#23244d]'
                        : 'border-l-white'
                    }`}
                    style={{ borderTop: "4px solid transparent", borderBottom: "4px solid transparent" }}
                  />
                </motion.div>
              </motion.button>
            ))}
          </div>
        )}
      </AnimatePresence>

      {/* Main toggle button */}
      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-16 h-16 rounded-full shadow-2xl backdrop-blur-md border-2 transition-all duration-300 ${
          dark
            ? 'bg-gradient-to-br from-indigo-600 to-purple-600 border-indigo-400/50 hover:border-indigo-400'
            : 'bg-gradient-to-br from-indigo-600 to-purple-600 border-indigo-500/50 hover:border-indigo-500'
        }`}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <motion.div
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.3 }}
          className="text-white text-2xl"
        >
          {isOpen ? "✕" : "💬"}
        </motion.div>
      </motion.button>
    </div>
  );
} 